/* eslint @typescript-eslint/no-explicit-any: 0 */

import { Question, newQuestion } from "../types/Question";
import QuestionForm from "../components/thread/QuestionForm";
import { useAuth } from "../contexts/auth.context";
import { useCreateQuestionMutation } from "../../features/api/questionSlice";

import React, { useState } from "react";
import { Box, Container, Toolbar, Card, CardContent, Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

const AskQuestion: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useAuth();
    const [createQuestion, { isLoading: loadingCreateQuestion }] = useCreateQuestionMutation();
    const enteredText: string = location.state ? location.state.enteredText : "";
    window.history.replaceState({}, ""); // reset state
    const [question, setQuestion] = useState<Question>(newQuestion(user, "", enteredText));

    async function handleQuestionSubmit() {
        // Submit question through api
        if (!loadingCreateQuestion) {
            try {
                const id = await createQuestion(question).unwrap();
                navigate(`/question/${id}`);
                return true;
            } catch (error: any) {
                if (error.status === 400) {
                    return false;
                } else {
                    throw error;
                }
            }
        }
        return true;
    }

    function handleQuestionCancel() {
        navigate("/forum");
    }

    return (
        <Box
            component="main"
            sx={{
                backgroundColor: (theme) =>
                    theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[900],
                flexGrow: 1,
                height: "100vh",
                overflow: "auto",
            }}
        >
            <Toolbar />
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                <Card sx={{ display: "grid" }}>
                    <CardContent>
                        <Typography variant="h4" m={2}>
                            Ask a question
                        </Typography>
                        <Box m={2}>
                            <QuestionForm
                                question={question}
                                onQuestionChange={setQuestion}
                                onSubmit={handleQuestionSubmit}
                                onCancel={handleQuestionCancel}
                            />
                        </Box>
                    </CardContent>
                </Card>
            </Container>
        </Box>
    );
};

export default AskQuestion;
